export const stringsKey = "BatchNotificationWizard";
export const englishStrings = {
	nextButton: "Next",
	backButton: "Back",
	step1Text: "Select Message Type",
	step2Text: "Configure Message",
	step3Text: "Configure Group",
	step4Text: "Configure Schedule For Sending Message",
	step5Text: "Configure Message Sender",
	step6Text: "Send Out Test Message",
	testButton: "Send test message",
	saveAsDraftButton: "Submit for Approval",
	savePreConfigurationDetailSuccessMessage:
		"Batch Messaging Template detail saved successfully",
	savePreConfigurationDetailErrorMessage:
		"Error submitting Batch Messaging Template configuration, please try again",
	notificationDetailErrorMessage:
		"Error loading batch messaging template detail",
	approveButton: "Approve",
	rejectButton: "Reject",
	approveTemplateSuccessMessage: "Approve template request saved successfully",
	approveTemplateErrorMessage: "Error approving template, please try again",
	rejectTemplateSuccessMessage: "Reject template request saved successfully",
	rejectTemplateErrorMessage:
		"Error in reject template request, Please try again",
	saveLanguageDetailErrorMessage:
		"Error submitting message and language detail, Please try again",
	saveLanguageDetailSuccessMessage:
		"Message and language detail saved successfully",
	saveGroupDetailSuccessMessage: "Group detail saved successfully",
	saveGroupDetailErrorMessage:
		"Error submitting group detail, Please try again",
	rejectTemplateConfirmationMessage:
		"Are you sure you want to reject template configuration?",
	deleteButtonText: "Yes",
	cancelButtonText: "No",
	saveSenderDetailSuccessMessage: "Message sender detail saved successfully",
	saveSenderDetailErrorMessage:
		"Error submitting message sender detail, Please try again",
	saveScheduleDetailSuccessMessage:
		"Message and schedule detail saved successfully",
	saveScheduleDetailErrorMessage:
		"Error submitting message and schedule detail, Please try again",
	noMessageSelectedText: "Select at least one message.",
	noPhoneNumberAddedText: "Please provide at least one phoneNumber.",
	messageScheduleSuccessMessage: "Batch message detail scheduled.",
	messageScheduleErrorMessage:
		"Error submitting save schedule message request, Please try again",
	saveAsDraftErrorMessage:
		"Error submitting save batch message draft request, Please try again",
	saveAsDraftSuccessMessage: "Batch message detail saved as draft",
	noLanguageSelectedText: "No language(s) selected",
	readManualText: "For more information: read the full manual",
	hereText: "here",
};
